import { PropsWithChildren, useMemo } from 'react';

import { BaseTooltip } from '@/components/common/base-tooltip';
import { useOrderbookStore } from '@/store/orderbook';

interface Props extends PropsWithChildren {
  cost: {
    amountWithFee: number;
    feeAmount: number;
    amount: number;
    avgPrice: number | string;
  };
}

export const EventTotalCostTooltip = ({ children, cost }: Props) => {
  const { isUsdc } = useOrderbookStore();
  const Icon = (
    <img
      src={`/icons/${isUsdc ? 'usdc' : 'sol'}.svg`}
      alt={isUsdc ? 'usdc' : 'sol'}
      className="h-5 w-5"
    />
  );

  const avgPrice = useMemo(() => {
    const price = Number(cost.avgPrice || 0);

    return `${price.toFixed(2)}¢`;
  }, [cost.avgPrice]);

  return (
    <BaseTooltip
      asChild
      content={
        <div className="flex flex-col gap-2 text-base">
          <div className="flex flex-row items-center gap-1">
            <p>Estimated Avg. Fill Price</p>
            <p>{avgPrice}</p>
          </div>
          {cost.feeAmount > 0 && (
            <>
              <div className="flex flex-row items-center gap-1">
                <p>Order cost: {cost.amount.toFixed(isUsdc ? 3 : 6)}</p>
                {Icon}
              </div>
              <div className="flex flex-row items-center gap-1">
                <p>Fee: {cost.feeAmount.toFixed(isUsdc ? 3 : 6)}</p>
                {Icon}
              </div>
              <div className="flex flex-row items-center gap-1">
                <p>Total: {cost.amountWithFee.toFixed(isUsdc ? 3 : 6)}</p>
                {Icon}
              </div>
            </>
          )}
        </div>
      }
    >
      {children}
    </BaseTooltip>
  );
};
